<div class="ticket-container" [style]="'--corp-color-1: ' + corpColor() + ';'">
    <h2 class="text-l mb-1 dialog-title">
        @if (communityCode() === ticketsAsEntradasCommunity) {
            {{ (fullFree() ? 'TICKETS.ENTRADAS.ReserveYourTickets' : 'TICKETS.ENTRADAS.BuyYourTickets') | translate }}
        } @else {
            {{ (fullFree() ? 'TICKETS.ReserveYourTickets' : 'TICKETS.BuyYourTickets') | translate }}
        }
    </h2>
    <div class="ticket mb-1">
        <div class="info">
            <h3>{{ ticket().title }}</h3>
        </div>
    </div>
</div>

@if (swiperLoaded()) {    
    <swiper-container
        slides-per-view="1"
        loop="false"
        #swiper 
        allow-touch-move="false"
        auto-height="true"
        space-between="5"
        (swiperslidechange)="slideChange($event)">
        <swiper-slide>
            <app-tickets
                [ticket]="ticket()"
                [waitingListUserDetails]="waitingListUserDetails"
                [communityCode]="communityCode()"
                [discountedTotal]="appliedCoupon() ? displayTotal() : null"
                [originalTotal]="appliedCoupon()?.originalTotalWithFee ?? null"
                (emitNext)="changeStep($event, 'ticket')"
                (swiperLoaded)="onSlideLoaded($event)"
                (onAvailabilityChanged)="availableTickets.set($event)"
            />
        </swiper-slide>                

        <swiper-slide>
            <reservation-countdown
                [reservedSeconds]="reservedSeconds()"
                (onCountdownEnd)="countdownEnd($event)"
                ui="block"
                class="mb-3"
            />

            @if (ticket().multipleInscriptions) {
                <h2 class="mt-3 mb-0">{{ 'Modules.Inscriptions.Multi-inscription.ResponsibleData' | translate }}</h2>
            }
            <app-user-data
                [customFields]="customFieldsForm()"
                [fullFree]="fullFree()"
                [submitAttempt]="submitAttempt"
                [rgpd]="ticket().rgpd"
                (userEmitter)="changeStep($event, 'user')"                
            />
        </swiper-slide>            

        @if (reservedSeconds() && holdersDataWithCustomFields()) {
            @for (holder of holdersData(); track $index) {

                <swiper-slide>
                    <reservation-countdown
                        [reservedSeconds]="reservedSeconds()"
                        (onCountdownEnd)="countdownEnd($event)"
                        ui="block"
                    >
                        <i class="fa-solid fa-ticket me-1"></i> 
                        @if (holdersData().length > 1){
                            {{($index + 1)}} / {{holdersData().length}} - 
                        }
                        {{ holder.priceName }}
                    </reservation-countdown>

                    <app-holder-form
                        (onStepValid)="changeStep($event, 'holder')"
                        [customFields]="holder.customFields"
                        class="mt-2"                                    
                    />
                </swiper-slide>
            }
        }
    </swiper-container>
} @else {
    <div class="ticket-container" [style]="'--corp-color-1: ' + corpColor() + ';'">
        <div class="ticket mb-3">
            <div class="row justify-content-between mt-1 mb-1">
                <div class="price-info col-5 col-md-5">
                    <p-skeleton styleClass="w-50 mt-1"></p-skeleton>
                    <p-skeleton styleClass="w-25 mt-2"></p-skeleton>
                </div>
                <div class="col-md-3 col-5">
                    <p-skeleton styleClass="w-100" height="50px"></p-skeleton>
                </div>    
            </div>
            <div class="row justify-content-between mt-1 mb-1">
                <div class="price-info col-5 col-md-5">
                    <p-skeleton styleClass="w-50 mt-1"></p-skeleton>
                    <p-skeleton styleClass="w-25 mt-2"></p-skeleton>
                </div>
                <div class="col-md-3 col-5">
                    <p-skeleton styleClass="w-100" height="50px"></p-skeleton>
                </div>
            </div>
        </div>
        <div class="total-box">
            <p-skeleton styleClass="w-50"></p-skeleton>
        </div>
    </div>
}



@if (false) {
    <span style="font-size:14px" class="mt-4" *ngIf=" currentSlide() == 1">
        {{'EVENTS.acceptancePrivacityFirstPart' | translate}} "{{ (totalPrice() === 0 || !ticket().paymentMethodId) ? ('End' | translate) : ('Pay' | translate) }}", {{'EVENTS.acceptancePrivacitysecondPart' | translate}}<a target="_blank" [href]="privacyUrl">{{'EVENTS.acceptancePrivacitythirdPart' | translate}}</a> {{'EVENTS.acceptancePrivacityfourPart'|translate}} <a target="_blank" [href]="termsUrl">{{'EVENTS.acceptancePrivacityfivePart'|translate}}</a>
    </span>
}

<div class="d-flex flex-column gap-2 align-items-stretch mt-3">
    @if (currentSlide() === 0 && !fullFree() && showCouponInput()) {
        <div class="coupon-box" [style]="'--corp-color-1: ' + corpColor() + ';'">
            <label class="coupon-label" for="ticket-coupon-code">{{ 'TICKETS.COUPON.LABEL' | translate }}</label>
            <div class="coupon-row">
                <input
                    id="ticket-coupon-code"
                    type="text"
                    class="coupon-input"
                    [ngModel]="couponInput()"
                    (ngModelChange)="couponInput.set($event)"
                    [disabled]="couponApplying() || hasActiveCoupon() || quantity() === 0"
                    [attr.aria-invalid]="couponError() ? true : null"
                    [attr.aria-describedby]="couponError() ? 'ticket-coupon-error' : null"
                    autocomplete="off"
                />
                @if (!hasActiveCoupon()) {
                    <button
                        type="button"
                        class="btn-buy coupon-apply-btn"
                        (click)="applyCoupon()"
                        [disabled]="couponApplying() || !couponInput()?.trim() || quantity() === 0"
                        [style.background-color]="corpColor()"
                    >
                        @if (couponApplying()) {
                            <app-spinner size="s"></app-spinner>
                        } @else {
                            <span>{{ 'TICKETS.COUPON.APPLY' | translate }}</span>
                        }
                    </button>
                } @else {
                    <button
                        type="button"
                        class="btn-buy coupon-apply-btn"
                        (click)="removeCoupon()"
                        [disabled]="couponApplying()"
                        [style.background-color]="corpColor()"
                    >
                        @if (couponApplying()) {
                            <app-spinner size="s"></app-spinner>
                        } @else {
                            <span>{{ 'TICKETS.COUPON.REMOVE' | translate }}</span>
                        }
                    </button>
                }
            </div>

            @if (couponError()) {
                <p id="ticket-coupon-error" class="coupon-error" role="alert">{{ couponError() }}</p>
            }

            @if (appliedCoupon(); as coupon) {
                <p class="coupon-success" role="status">
                    {{ 'TICKETS.COUPON.APPLIED' | translate:{ code: coupon.code, amount: coupon.discountAmount } }}
                </p>
            }
        </div>
    }

    @if (currentSlide() === 0) {
        <div class="total-price coupon-total">
            <span>{{ 'Total' | translate }}:</span>
            @if (appliedCoupon()) {
                <span class="strike">{{ (appliedCoupon()?.originalTotalWithFee ?? totalPrice()) | currency:'€' }}</span>
                <strong>{{ displayTotal() | currency:'€' }}</strong>
            } @else {
                <strong>{{ (totalPrice() ?? 0) | currency:'€' }}</strong>
            }
        </div>
    }

    <div class="mt-1 buy-box">
        @if (currentSlide() != 0) {
            <button
                class="btn-buy"
                (click)="prev()"            
                [style.background-color]="corpColor()">
                @if (!buttonPrevLoading()){
                    <span>{{ 'Previous' | translate }}</span>
                } @else {
                    <app-spinner size="s"></app-spinner>
                }            
            </button>
        } 

        <button
            type="submit"
            class="btn-buy"
            [class.disabled-btn]="!canContinue() || buttonLoading()"
            [class.disabled-color]="currentSlide() === lastSlide() && !formIsValid"
            (click)="next()"
            [style.background-color]="corpColor()"
        >
            @if (!buttonLoading()){
                @if (lastSlide() === currentSlide()) {
                    @if (displayTotal() === 0 || !ticket().paymentMethodId) {
                        <span>{{ 'End' | translate }}</span>
                    } @else {
                        <span>{{ 'Pay' | translate }}</span>
                    }
                } @else {
                    <span>{{ 'Next' | translate }}</span>
                }
            } @else {
                <app-spinner size="s"></app-spinner>
            }
        </button>
    </div>
</div>

